import { Upload } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface FileUploadZoneProps {
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
  isUploading: boolean;
  uploadProgress: number;
  disabled?: boolean;
}

export function FileUploadZone({ 
  onFileSelect, 
  isUploading, 
  uploadProgress, 
  disabled 
}: FileUploadZoneProps) {
  return (
    <div className="flex flex-col items-center justify-center w-full space-y-4">
      <label
        htmlFor="file-upload"
        className={`flex flex-col items-center justify-center w-full h-64 border-2 border-dashed rounded-lg cursor-pointer 
          ${disabled 
            ? 'bg-muted cursor-not-allowed' 
            : 'bg-background hover:bg-accent/50'} 
          ${isUploading ? 'opacity-50' : ''} 
          border-accent transition-all duration-200`}
      >
        <div className="flex flex-col items-center justify-center pt-5 pb-6">
          <Upload className={`w-12 h-12 mb-4 text-muted-foreground ${isUploading ? 'animate-bounce' : ''}`} />
          <p className="mb-2 text-lg font-semibold text-muted-foreground">
            {disabled 
              ? 'Please select at least one income type'
              : isUploading
                ? 'Uploading...'
                : 'Drag & drop your files here or click to browse'
            }
          </p>
          <p className="text-sm text-muted-foreground">
            Accepted formats: PDF, JPG, PNG (Max 10 MB per file)
          </p>
        </div>
        <input
          id="file-upload"
          type="file"
          className="hidden"
          accept=".pdf,.png,.jpg,.jpeg"
          onChange={onFileSelect}
          disabled={isUploading || disabled}
        />
      </label>
      
      {isUploading && (
        <div className="w-full space-y-2">
          <Progress value={uploadProgress} className="w-full" />
          <p className="text-sm text-center text-muted-foreground">
            Uploading... {uploadProgress}%
          </p>
        </div>
      )}
    </div>
  );
}